import React, { useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import styles from './CustomizedZendesk.module.scss';
import Zendesk from 'react-zendesk';
import { ZENDESK_KEY } from '../../constants/zendesk';
import { ZendeskAPI } from 'react-zendesk';
import { useHistory, useLocation } from 'react-router';
import { connect } from 'react-redux';

const setting = {
	color: {
		theme: '#0046B9',
		button: '#fff',
	},
	launcher: {
		label: {
			'en-US': 'Support',
		},
		color: '#fff',
	},
	contactForm: {
		fields: [
			{
				id: 'description',
				prefill: { '*': 'Describe your issue.' },
			},
		],
	},
};

const CustomizedZendesk = ({ currentLocation }) => {
	const iconBtnClickHandler = () => {
		ZendeskAPI('webWidget', 'toggle');
		console.log('zendesk click', ZendeskAPI);
	};

	return (
		<>
			<Zendesk zendeskKey={ZENDESK_KEY} {...setting} />

			{currentLocation === 'profile' && (
				<IconButton
					color='primary'
					className={styles.zendesk_button}
					onClick={iconBtnClickHandler}
				>
					<HelpIcon className={styles.zendesk_button_icon} />
				</IconButton>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	currentLocation: state.location.location,
});

export default connect(mapStateToProps)(CustomizedZendesk);
